import cl from 'classnames'
import styles from './NominationHeader.module.scss'
import dayjs from 'dayjs'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { DataGridTable } from '@/ui'
import { getCurrentLanguage } from '@/i18next'
import { LANGUAGE_ENUM } from '@/shared'
import { NOMINATION_STATUSES_LABEL } from '@/entity/nomination'

export const NominationHeader = ({item}) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const lang = getCurrentLanguage()

	let region = {
		[LANGUAGE_ENUM.rus]: item?.katoAB?.nameRu,
		[LANGUAGE_ENUM.kz]: item?.katoAB?.nameKz,
	}

	let nomination = {
		[LANGUAGE_ENUM.rus]: item?.nomination?.nameRu,
		[LANGUAGE_ENUM.kz]: item?.nomination?.nameKz,
	}

	let category = {
		[LANGUAGE_ENUM.rus]: item?.category?.nameRu,
		[LANGUAGE_ENUM.kz]: item?.category?.nameKz,
	}

	const info = [
		{
			title: t('accidentsPage.view.organization'),
			data: item?.orgName || '-',
		},
		{
			title: t('bin'),
			data: item?.bin || '-',
		},
		{
			title: t('region'),
			data: region[lang] || '-',
		},
		{
			title: 'E-mail',
			data: item?.email || '-',
		},
		{
			title: t('officePhone'),
			data: item?.workPhone || '-',
		},
		{
			title: t('mobilePhone'),
			data: item?.mobilePhone || '-',
		},
		{
			title: t('nomination.fioDirector'),
			data: item?.directorFullName || '-',
		},
		{
			title: t('nomination.foundationDate'),
			data: item?.foundationDate || '-',
		}
	]

	const nominationInfo = [
		{
			title: t('nomination.nomination'),
			data: nomination?.[lang] || '-',
		},
		{
			title: t('nomination.create.category'),
			data: category?.[lang] || '-',
		},
	]

	return (
		<div>
			<div className={cl('flex', 'justify-content-between', 'align-items-center', 'flex-row', 'gap-5', 'mb-3')}>
				<h3 className={cl(styles.titlebig, 'flex-2')}>{t('nomination.view.title')}</h3>

				<span className={cl(styles.status)}>{t(NOMINATION_STATUSES_LABEL[item?.status]) || ''}</span>
			</div>

			<p className={styles.id}>
				ID: {item?.externalId}
			</p>

			<p className={styles.date}>
				{t('nomination.view.date_pass', { date: item?.createDate })}
			</p>

			<div>
				<DataGridTable
					hideSubTitle
					hideTitle
					hideCustomTitle
					information={info}
					titleClass={styles.tableTitleCell}
				/>
			</div>

			<div className={cl('mt-4')}>
				<DataGridTable
					hideSubTitle
					hideTitle
					hideCustomTitle
					information={nominationInfo}
					titleClass={styles.tableTitleCell}
				/>
			</div>
		</div>
	)
}